import { Dialog, DialogTitle } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearEntry,
  clearEntryMessage,
  createEntry,
  saveEntry,
  CREATE_ENTRY,
  SAVE_ENTRY,
} from '../../redux/entry';
import {
  ENTRY_TYPE_DRAFT,
  ENTRY_TYPE_EXPENSE,
  ENTRY_TYPE_SERVICE,
} from '../../config/staticValues';
import EntryForm from '../../containers/EntryForm';
import ExpenseForm from '../../containers/ExpenseForm';
import { resetReceipt } from '../../redux/receipt';

const EntryModal = ({ disabled }) => {
  const dispatch = useDispatch();
  const timecardEndDate = useSelector((state) => state.timecard?.endDate);
  const entry = useSelector((state) => state.entry);
  const entryId = entry.id;
  const entryType = entry.type;
  const isServiceEntry = entryType?.toUpperCase() == ENTRY_TYPE_SERVICE;
  const isDraftEntry = entryType?.toUpperCase() == ENTRY_TYPE_DRAFT;
  const isExpenseEntry = entryType?.toUpperCase() == ENTRY_TYPE_EXPENSE;
  const onSave = useCallback((newEntry) => {
    if (entryId === -1) dispatch(createEntry(newEntry, (isExpenseEntry)));
    else dispatch(saveEntry(newEntry, (isExpenseEntry)));
  }, [dispatch, entryId, isExpenseEntry]);
  const onClose = useCallback(() => {
    dispatch(clearEntry());
    if (isExpenseEntry)
      dispatch(resetReceipt());
  }, [dispatch, isExpenseEntry]);
  const actionText = entryId === -1 ? 'Add ' : 'Edit ';
  const typeText = isExpenseEntry ? 'Expense' : 'Entry';
  return (
    <Dialog open={entryId ? true : false} onClose={onClose}>
      <DialogTitle>
        {actionText} {typeText} {entryId > 0 ? ' - ' + entryId : ''}
      </DialogTitle>
      {(isServiceEntry || isDraftEntry) && (
        <EntryForm
          entry={entry}
          onSave={onSave}
          onCancel={onClose}
          disabled={disabled}
          autoSave={false}
          apiLabel={entryId === -1 ? CREATE_ENTRY : SAVE_ENTRY}
          onClearMessage={() => dispatch(clearEntryMessage())}
          onValidate={(entry) => {
            if (
              !entry.incidentId ||
              !entry.taskId ||
              !entry.startDate ||
              !entry.startTime ||
              !entry.endDate ||
              !entry.endTime ||
              !entry.description ||
              entry.startDate.substr(0, 10) > timecardEndDate
            )
              return {
                incident: !entry.incidentId ? 'Required' : undefined,
                task: !entry.taskId ? 'Required' : undefined,
                startDate: !entry.startDate
                  ? 'Required'
                  : entry.startDate.substr(0, 10) > timecardEndDate
                    ? 'After period end'
                    : undefined,
                startTime: !entry.startTime ? 'Required' : undefined,
                endDate: !entry.endDate ? 'Required' : undefined,
                endTime: !entry.endTime ? 'Required' : undefined,
                description: !entry.description ? 'Required' : undefined,
              };
            else return undefined;
          }}
        />
      )}
      {isExpenseEntry && (
        <ExpenseForm
          defaultDirty={entryId === -1}
          onSave={onSave}
          onCancel={onClose}
          disabled={disabled}
          apiLabel={entryId === -1 ? CREATE_ENTRY : SAVE_ENTRY}
        />
      )}
    </Dialog>
  );
};

export default EntryModal;
